import {Directive, ViewContainerRef} from '@angular/core';

@Directive({standalone: true, selector: '[pubResultPage]'})
export class ResultPageDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}
